<app-content>
  <section>
    <h2>
      Błąd
    </h2>
  </section>
  <div>
    <p>
      <strong>
        404&nbsp;
      </strong>
      <br>
      ☹ Strona nie znaleziona!
      <br>
      @if (!uiSettings()?.mobileEmbed) {
        <a title='Powrót' routerLink='/'>Powrót do głownej</a>
      }
    </p>
  </div>
</app-content>
